import { jsx as _jsx } from "react/jsx-runtime";
/**
 * AdminCataloguePage — Wine catalogue management tab (wines, producers, merchants, bonded stores).
 *
 * Wraps PlatformAdminPage with padding to match the other admin console pages.
 * The original component has no outer padding because it previously rendered
 * inside AppLayout which supplied it; here it renders directly in AdminLayout's
 * padding-free <main> element.
 */
import { PlatformAdminPage } from './PlatformAdminPage';
export function AdminCataloguePage() {
    return (_jsx("div", { className: "p-6", children: _jsx(PlatformAdminPage, {}) }));
}
